import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "../components/ui/button";

const LOGO_URL = "/novapine-logo.png";

const navLinks = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Products", to: "/products" },
  { label: "Contact", to: "/contact" },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  return (
    <nav
      data-testid="navbar"
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#F9F6F0]/80 border-b border-[#E2E0D5]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex items-center justify-between h-24 md:h-28">
        {/* Logo */}
        <Link to="/" data-testid="navbar-logo" className="flex items-center gap-3">
          <img
            src={LOGO_URL}
            alt="Novapine Logo"
            className="h-20 md:h-24 w-auto object-contain"
          />
          <span className="font-heading font-bold text-2xl md:text-3xl tracking-tight text-novapine-brown">
            NOVAPINE
          </span>
        </Link>

        {/* Desktop links */}
        <div className="hidden md:flex items-center gap-10">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              data-testid={`nav-link-${link.label.toLowerCase()}`}
              className={`nav-link font-heading text-sm tracking-wide uppercase ${
                location.pathname === link.to
                  ? "text-novapine-brown font-semibold"
                  : "text-novapine-brown/70 hover:text-novapine-brown"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        {/* Desktop CTA */}
        <div className="hidden md:block">
          <Link to="/contact">
            <Button
              data-testid="nav-cta-button"
              className="btn-primary-novapine rounded-md px-6 font-heading text-sm tracking-wide"
            >
              Enquire Now
            </Button>
          </Link>
        </div>

        {/* Mobile hamburger */}
        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden p-2 text-novapine-brown"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-[#F9F6F0]/95 backdrop-blur-xl border-t border-[#E2E0D5] px-6 pb-6 pt-4 animate-fade-in"
        >
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              data-testid={`mobile-nav-link-${link.label.toLowerCase()}`}
              className={`block py-3 font-heading text-base tracking-wide ${
                location.pathname === link.to
                  ? "text-novapine-brown font-semibold"
                  : "text-novapine-brown/70"
              }`}
              onClick={() => setMobileOpen(false)}
            >
              {link.label}
            </Link>
          ))}
          <Link to="/contact" onClick={() => setMobileOpen(false)}>
            <Button
              data-testid="mobile-cta-button"
              className="btn-primary-novapine rounded-md w-full mt-4 font-heading text-sm tracking-wide"
            >
              Enquire Now
            </Button>
          </Link>
        </div>
      )}
    </nav>
  );
}
